import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { GENERAL_RULES_CONSTANTS } from "../../constants/GeneralRulesConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import OperationComponent from "./components/OperationComponent/OperationComponent.vue";
import InformationComponent from "./components/InformationComponent/InformationComponent.vue";
import lodash from "lodash";
import Vuetify from "vuetify";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { Http } from "@status/codes";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { Field } from "@/modules/FormTemplate/models/Field";
import { FormConfiguration } from "../../models/FormConfiguration.model";
import {
  FORM_ACTION_CONSTANTS,
  FORM_ACTION_INIT,
  TABS
} from "./constants/FormActionModal.constants";
import { FormInformation } from "../../models/FormInformationMapped.model";
import { FormOperation } from "../../models/FormOperation.model";
import { KeyValue } from "@/shared/models/KeyValue";
import { LogicalField } from "../../models/LogicalField.model";
import { AxiosError } from "axios";
import { FORM_TEMPLATES_ACCESS } from "@/modules/FormTemplate/constants/FormTemplateConstants";

Vue.use(Vuetify);
@Component({
  name: "FormActionModal",
  components: {
    InformationComponent,
    OperationComponent
  }
})
export default class FormActionModal extends Vue {
  @Prop({ default: false }) dialog!: boolean;
  @Prop({ default: false }) isEditing!: boolean;
  @Prop() editingFormConfiguration!: FormConfiguration;

  @Inject() formTemplateService!: FormTemplateService;

  SAVE_BTN_LABEL = GENERAL_RULES_CONSTANTS.TOOLTIP.SAVE;
  CANCEL_BTN_LABEL = GENERAL_RULES_CONSTANTS.TOOLTIP.CANCEL;

  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;

  TABS = TABS;
  resetComponent = 0;
  INFORMATION = FORM_ACTION_CONSTANTS.LABELS.TABS.INFORMATION;
  OPERATION = FORM_ACTION_CONSTANTS.LABELS.TABS.OPERATION;

  ARITHMETIC = FORM_ACTION_CONSTANTS.FIELD_OPERATION.ARITHMETIC;
  GET_COUNT = FORM_ACTION_CONSTANTS.FIELD_OPERATION.GET_COUNT;
  LOGIC = FORM_ACTION_CONSTANTS.FIELD_OPERATION.LOGIC;
  SAME_FIELD = FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD;
  infoOperations = [
    FORM_ACTION_CONSTANTS.INFO_OPERATION.COUNT,
    FORM_ACTION_CONSTANTS.INFO_OPERATION.GET,
    FORM_ACTION_CONSTANTS.INFO_OPERATION.GET_MULTIPLE
  ];
  fieldOperations = [
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.ARITHMETIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.GET_COUNT,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.LOGIC,
    FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD
  ];
  sameFieldOperations = [
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.ADDITION,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.AVERAGE,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.HIGHER,
    FORM_ACTION_CONSTANTS.SAME_FIELD_OPERATORS.SMALLER
  ];
  logicConnectors = [
    FORM_ACTION_CONSTANTS.LOGIC_CONNECTORS.AND,
    FORM_ACTION_CONSTANTS.LOGIC_CONNECTORS.OR
  ];
  comparationOperations = [
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.DIFFERENT,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.EQUAL,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.LESS_OR_EQUAL,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.LESS_THAN,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.MORE_OR_EQUAL,
    FORM_ACTION_CONSTANTS.COMPARATION_OPERATION.MORE_THAN
  ];
  selectedTab = TABS.INFORMATION;

  editingEvent = 0;

  formTemplates: FormStatus[] = [];
  fields: Field[] = [];
  formConfiguration: FormConfiguration = lodash.cloneDeep(FORM_ACTION_INIT);
  enableSaveButton = false;
  lastRefFormTemplate: string | undefined = undefined;
  editComparationStr = "";
  invalidEdit = false;

  async mounted() {
    await this.loadFormTemplates();
    await this.loadFormTemplatesToEdit(
      this.editingFormConfiguration.information.map(
        info => info.formTemplate as string
      )
    );
    this.mapEditingConfiguration();
  }

  async loadFormTemplatesToEdit(formTemplatesIds: string[]) {
    for (const id of formTemplatesIds) {
      const responseData = await this.formTemplateService.getFormTemplateById(
        id
      );
      if (responseData.code === Http.Found && responseData.data) {
        const templated = {
          ...responseData.data,
          status: responseData.data.state
        };
        this.formTemplates = [
          ...this.formTemplates,
          { ...(templated as FormStatus) }
        ].sort((template1, template2) =>
          template1.name.localeCompare(template2.name)
        );
      }
    }
  }

  async handleFormTemplates(name: string) {
    const responseData = await this.formTemplateService.getFormTemplateWithFilters(
      {
        name,
        state: GENERAL_RULES_CONSTANTS.ACTIVO
      }
    );
    if (responseData.code === Http.Found && responseData.data) {
      this.formTemplates = [
        ...this.formTemplates,
        ...responseData.data.data
      ].sort((template1, template2) =>
        template1.name.localeCompare(template2.name)
      );
    }
  }

  async loadFormTemplates(templateName?: string) {
    try {
      if (templateName) {
        await this.handleFormTemplates(templateName);
        return;
      }
      const queryFormTemplates = {
        paginatedResult: true,
        state: GENERAL_RULES_CONSTANTS.ACTIVO,
        docref: this.lastRefFormTemplate
      };
      const response = await this.formTemplateService.getFormTemplateWithFilters(
        queryFormTemplates
      );
      if (response.code === Http.Found && response.data) {
        if (this.lastRefFormTemplate) {
          this.formTemplates = [...this.formTemplates, ...response.data.data];
        } else {
          this.formTemplates = response.data.data;
        }

        if (this.isEditing) {
          await this.getFormsTemplatesToEdit();
        }

        this.formTemplates = this.formTemplates.sort((template1, template2) =>
          template1.name.localeCompare(template2.name)
        );
        this.lastRefFormTemplate = response.data.docref;
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getFormsTemplatesToEdit() {
    const formConfigurated = this.formTemplates.find(
      (formTemplate: FormStatus) =>
        formTemplate.name === this.editingFormConfiguration.formName
    );
    const formToGenerate = this.formTemplates.find(
      (formTemplate: FormStatus) =>
        formTemplate.name ===
        (this.editingFormConfiguration.formToGenerate as FormStatus).name
    );

    if (!formConfigurated) {
      await this.getFormTemplate(this.editingFormConfiguration.formName);
    }
    if (!formToGenerate) {
      await this.getFormTemplate(
        (this.editingFormConfiguration.formToGenerate as FormStatus).name
      );
    }
  }

  async getFormTemplate(formTemplateName: string) {
    try {
      const response = await this.formTemplateService.getFormTemplateWithFilters(
        { name: formTemplateName }
      );

      if (response.code === Http.Found && response.data) {
        this.formTemplates = [...this.formTemplates, ...response.data.data];
      } else {
        Snackbar.popError(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
  @Watch("isEditing")
  mapEditingConfiguration() {
    if (this.isEditing) {
      this.formConfiguration = lodash.cloneDeep(this.editingFormConfiguration);
      this.formConfiguration.formToGenerate = this.getTemplate(
        this.editingFormConfiguration.formToGenerate as string
      );
      this.formConfiguration.formName = this.editingFormConfiguration.formName;
      this.formConfiguration.information = this.mapInformationData(
        this.formConfiguration.information
      );
      this.formConfiguration.operations = this.mapOperationData(
        this.formConfiguration.operations,
        this.formConfiguration.information
      );
      this.fields = (this.editingFormConfiguration
        .formToGenerate as FormStatus).fields;
      this.editingEvent = 1 - this.editingEvent;
      this.editComparationStr = JSON.stringify(this.formConfiguration);
    } else {
      this.formConfiguration = lodash.cloneDeep(FORM_ACTION_INIT);
    }
  }

  mapInformationData(formInformationArray: FormInformation[]) {
    return formInformationArray.map(information => {
      information.formTemplate = this.getTemplate(
        information.formTemplate as string
      );
      const infoOperation = this.infoOperations.find(
        info => info.key === information.operation
      );
      information.operation = infoOperation ?? "";
      const field = (information.formTemplate as FormStatus).fields.find(
        field => field.key === (information.field as string)
      );
      information.field = field ?? "";
      return information;
    });
  }

  mapOperationData(
    formOperationArray: FormOperation[],
    formInformationArray: FormInformation[]
  ) {
    return formOperationArray.map((operation: FormOperation) => {
      const fieldTemp = (this.formConfiguration
        .formToGenerate as FormStatus).fields.find(
        field => field.key === (operation.fieldToSet as string)
      );
      operation.fieldToSet = fieldTemp ?? "";
      const fieldOperation = this.fieldOperations.find(
        fieldOperation => fieldOperation.key === (operation.type as string)
      );
      operation.type = fieldOperation ?? "";
      if (
        (operation.type as KeyValue).key ===
        FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD.key
      ) {
        const sameFieldOp = this.sameFieldOperations.find(
          sameFieldOp => sameFieldOp.key === (operation.operation as string)
        );
        operation.operation = sameFieldOp ?? "";
      }
      if (operation.informationKey) {
        const tempInfo = formInformationArray.find(
          info => info.key === (operation.informationKey as string)
        );
        operation.informationKey = tempInfo ?? "";
      }
      if (operation.logicalFields && operation.logicalFields.length > 0) {
        operation.logicalFields = this.mapLogicOperations(
          operation.logicalFields,
          formInformationArray
        );
      }
      return operation;
    });
  }

  mapLogicOperations(
    logicalFields: LogicalField[],
    formInformationArray: FormInformation[]
  ) {
    return logicalFields.map(logicalField => {
      const info = formInformationArray.find(
        info => info.key === (logicalField.key as string)
      );
      logicalField.key = info ?? "";
      const operator = this.comparationOperations.find(
        comparation => comparation.key === (logicalField.operator as string)
      );
      logicalField.operator = operator ?? "";
      if (logicalField.connector) {
        const connector = this.logicConnectors.find(
          connector => connector.key === (logicalField.connector as string)
        );
        logicalField.connector = connector ?? "";
      }
      return logicalField;
    });
  }

  getTemplate(templateKey: string): FormStatus | string {
    const template = this.formTemplates.find(
      template => template._key === templateKey
    );
    return template ?? "";
  }

  changeTab(action: string) {
    this.selectedTab = action;
  }

  updateGenerationTemplate(template: FormStatus) {
    if (template) {
      this.formConfiguration.formToGenerate = template;
      this.formConfiguration.formName = template.name;
      this.fields = template.fields;
    } else {
      this.formConfiguration.formToGenerate = "";
      this.formConfiguration.formName = "";
      this.fields = [];
    }
  }

  fixInformationKeys() {
    this.formConfiguration.information = this.formConfiguration.information.map(
      (formInfo, index) => {
        formInfo.key = FORM_ACTION_CONSTANTS.INFORMATION_KEY + index;
        return formInfo;
      }
    );
  }

  addFormInformation(information: FormInformation) {
    this.formConfiguration.information.push(information);
  }

  @Watch("formConfiguration.information", { deep: true })
  onUpdateInformation() {
    this.enableSaveButton = !this.formConfiguration.information.find(
      e => e.validElement == false
    );
  }

  updateFormInformation(information: FormInformation, index: number) {
    Vue.set(this.formConfiguration.information, index, information);
  }

  deleteFormInformation(index: number) {
    this.formConfiguration.information.splice(index, 1);
    this.fixInformationKeys();
  }

  addFormOperation(operation: FormOperation) {
    this.formConfiguration.operations.push(operation);
  }

  updateFormOperation(operation: FormOperation, index: number) {
    Vue.set(this.formConfiguration.operations, index, operation);
  }

  deleteFormOperation(index: number) {
    this.formConfiguration.operations.splice(index, 1);
  }

  clearData() {
    this.selectedTab = TABS.INFORMATION;
    this.formConfiguration = lodash.cloneDeep(FORM_ACTION_INIT);
    this.editingEvent = 1 - this.editingEvent;
    this.resetComponent = 1 - this.resetComponent;
  }

  cancelFormAction() {
    this.clearData();
    this.$emit(FORM_ACTION_CONSTANTS.EVENTS.CANCEL);
    this.selectedTab = TABS.INFORMATION;
  }

  saveFormAction() {
    if (this.isValid()) {
      this.mapFormConfigurationData();
      this.$emit(FORM_ACTION_CONSTANTS.EVENTS.SAVE, this.formConfiguration);
      this.selectedTab = TABS.INFORMATION;
      this.clearData();
    } else {
      Snackbar.popError(FORM_ACTION_CONSTANTS.SNACKBAR.INVALID_OPERATIONS);
    }
  }

  mapFormConfigurationData() {
    this.formConfiguration.formToGenerate = (this.formConfiguration
      .formToGenerate as FormStatus)._key;
    this.formConfiguration.information = this.formConfiguration.information.map(
      information => {
        if (information.field !== "") {
          information.field = (information.field as Field).key;
        }
        information.formTemplate = (information.formTemplate as FormStatus)._key;
        information.operation = (information.operation as KeyValue).key;
        return information;
      }
    );
    this.formConfiguration.operations = this.formConfiguration.operations.map(
      operation => {
        operation.fieldToSet = (operation.fieldToSet as Field).key;
        operation.type = (operation.type as KeyValue).key;
        operation.informationKey = operation.informationKey
          ? (operation.informationKey as FormInformation).key
          : "";
        if (
          operation.type ===
          FORM_ACTION_CONSTANTS.FIELD_OPERATION.SAME_FIELD.key
        ) {
          operation.operation = (operation.operation as KeyValue).key;
        }
        if (operation.logicalFields && operation.logicalFields.length > 0) {
          operation.logicalFields = operation.logicalFields.map(infoField => {
            if (infoField.connector) {
              infoField.connector = (infoField.connector as KeyValue).key;
            }
            infoField.operator = (infoField.operator as KeyValue).key;
            infoField.key = (infoField.key as FormInformation).key;
            return infoField;
          });
        }
        return operation;
      }
    );
  }

  isValid(): boolean {
    const fields = (this.formConfiguration.formToGenerate as FormStatus).fields
      .filter(field => field.required)
      .map(field => field.key);

    const operationFields = this.formConfiguration.operations
      .filter(operation => this.isValidOperation(operation))
      .map(operation => (operation.fieldToSet as Field).key);

    let validation = true;
    for (const field of fields) {
      validation = operationFields.includes(field);
      if (!validation) break;
    }
    return validation;
  }

  isValidOperation(operation: FormOperation): boolean {
    switch ((operation.type as KeyValue).key) {
      case this.ARITHMETIC.key:
        return (
          operation.fieldToSet !== undefined &&
          operation.fieldToSet !== "" &&
          (operation.fieldToSet as Field).key !== "" &&
          operation.operation !== undefined &&
          operation.operation !== ""
        );
      case this.GET_COUNT.key:
        return (
          operation.fieldToSet !== undefined &&
          operation.fieldToSet !== "" &&
          (operation.fieldToSet as Field).key !== "" &&
          operation.informationKey !== undefined &&
          operation.informationKey !== "" &&
          (operation.informationKey as FormInformation).key !== ""
        );
      case this.LOGIC.key:
        return (
          operation.fieldToSet !== undefined &&
          operation.fieldToSet !== "" &&
          (operation.fieldToSet as Field).key !== "" &&
          operation.logicalFields !== undefined &&
          operation.logicalFields.length > 0
        );
      case this.SAME_FIELD.key:
        return (
          operation.fieldToSet !== undefined &&
          operation.fieldToSet !== "" &&
          (operation.fieldToSet as Field).key !== "" &&
          operation.operation !== undefined &&
          operation.operation !== "" &&
          (operation.operation as KeyValue).key !== "" &&
          operation.informationKey !== undefined &&
          operation.informationKey !== "" &&
          (operation.informationKey as FormInformation).key !== ""
        );
      default:
        return false;
    }
  }
}
